import { Wording } from '@/types';

export const COOKING_WORDING_FI: Wording = {
  components_header_media_content: 'Ruoanlaittovideot',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Reseptit',
  components_header_text2: 'Blogi',
  components_header_members: 'Jäsenet',
  hero_text: 'Kokkaa intohimoisesti, syö ilolla',
  hero_button_text: 'Aloita ruoanlaitto tänään',
  components_ressources_section_title: 'RESURSSIT',
  components_ressources_subheader_text: 'Kaikki tarvitsemasi resurssit oppimiseen, ruoanlaittoon ja paremman ruoan luomiseen',
  components_ressources_span_text: 'Tutustu rikkaaseen kokoelmaan videoreseptejä, yksityiskohtaisia ​​ruoanlaitto-oppaita ja asiantuntijoiden näkemyksiä makujen yhdistämisestä, ruoan esillepanosta ja kulinaarisesta luovuudesta.',
  components_ressources_card_1_title: 'Ruoanlaittoinspiraatiota',
  components_ressources_card_1_text: 'Inspiroidu luovista resepteistä ja ruoanlaittovideoista.',
  components_ressources_card_2_title: 'Ruoanlaittotietoa',
  components_ressources_card_2_text: 'Opi tärkeimmät ruoanlaittotekniikat, makuyhdistelmät ja ruokien yhdistämisen perusteet selkeiden ja käytännöllisten oppaiden avulla.',
  components_ressources_link: 'Katso videoita',
  components_notes_and_google_title_1: 'Ruoanlaitto-opetus',
  components_notes_and_google_title_2: 'Arkiruoanlaitto',
  components_notes_and_google_title_3: 'Johdonmukaiset ruoanlaittotaidot',
  components_review_google_text: 'Arvostelut Googlessa',
  media_content_section_title: 'Ruoanlaittovideot',
  media_content_section_subheader_text: 'Tutustu resepteihin ja vaiheittaisiin ruoanlaittovideoihin.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Lisää videoita',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Oppaat ja artikkelit',
  text2_section_button_more: 'Lisää artikkeleita',
  components_text1_section_title: 'RESEPTIT',
  components_text1_subheader_text: 'Herkullisia reseptejä arjen ruoanlaittoon',
  components_text1_span_text: 'Löydä helposti seurattavia reseptejä, jotka on suunniteltu arjen aterioihin, selkeisiin vaiheisiin ja loistaviin tuloksiin.',
  components_text1_card_1_title: 'Aloita päiväsi oikein',
  components_text1_card_1_text: 'Yksinkertaisia ​​ja maukkaita reseptejä, joilla aloitat päiväsi helposti ja maukkaasti.',
  components_text1_card_3_title: 'Maukkaita lounasideoita',
  components_text1_card_3_text: 'Herkullisia lounasreseptejä, jotka ovat helppoja valmistaa ja täynnä makua.',
  components_text1_card_2_title: 'Lohduttavat illallisreseptit',
  components_text1_card_2_text: 'Lämpimiä ja täyttäviä illallisreseptejä, jotka sopivat täydellisesti rentoihin iltoihin kotona.',
  components_text1_link: 'Näytä kaikki reseptit',
  components_footer_text: 'Opi parempaa ruoanlaittoa, luo parempaa ruokaa: sinun keittiösi, sinun matkasi.',
  components_footer_info: 'Tiedot',
  components_footer_registration_number: 'Rekisterinumero',
  components_footer_legal: 'Oikeudellinen',
  components_footer_terms: 'Käyttöehdot',
  components_footer_privacy: 'Tietosuojakäytäntö',
  button_load_more: 'Lataa lisää',
  page_media_1_content_hero_text: 'Löydä helppoja ruoanlaittovideoita jokaiseen makuun',
  page_text1_hero_text: 'Reseptit',
  page_text1_section_title: 'Ruoanlaittovinkkejä',
  page_text1_subheader_text: 'Reseptit',
  page_text2_hero_text: 'Blogimme',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Oppaat ja artikkelit',
  enter_email_title: 'Anna sähköpostiosoitteesi jatkaaksesi',
  enter_email_placeholder_email: 'Sähköposti',
  enter_email_button_enter: 'Syötä',
  components_login_success_text: 'Kirjautuminen onnistui!',
  components_card_link_media_content: 'Katso nyt',
  components_card_link_text1_content: 'Näytä resepti',
  components_card_link_text2_content: 'Näytä artikkeli',
};